import * as actionTypes from "./actionTypes";
import { contactUsService } from "../../service";

export function getContacts() {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.RESET_CONTACT_US });
      dispatch({ type: actionTypes.CONTACT_US });

      const response = await contactUsService.getAll();
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.CONTACT_US_FAILURE,
          payload: { error: data.message }
        });

        return;
      }

      dispatch({
        type: actionTypes.CONTACT_US_SUCCESS,
        payload: {
          contacts: data.data
        }
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.CONTACT_US_FAILURE);
    }
  };
}
export function resetContacts() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_CONTACT_US
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/contactUs/actions.js